// @ts-nocheck
import {
	acceptanceOptions,
	bergingOptionsSoort,
	bergingVoorzieningen,
	cnTypeOptions,
	formatBathroomAmentities,
	formatOptions,
	heatingOptions,
	isolationOptions,
	liggingOptions,
	specialOptions,
	tuinOptions,
} from "@/routes/properties";
import type * as api from "property-api/openapi";

export const PropertyDescriptiveDetails: React.FC<
	React.PropsWithChildren<{
		item: api.PropertyJsonld;
	}>
> = ({ item }) => {
	const showOverdracht =
		!!item.formattedPrice ||
		!!item.readableStatus ||
		!!item.financieel?.overdracht?.aanvaarding;
	const showBouwDetails =
		!!cnTypeOptions[item.algemeen?.woonhuistype] ||
		!!cnTypeOptions[item.algemeen?.appartementsoort] ||
		!!item.algemeen.bouwjaar ||
		!!cnTypeOptions[item.algemeen?.bouwvorm] ||
		!!item.algemeen.bijzonderheden?.length > 0;
	const showOppervlakte =
		!!item.livingArea ||
		!!item.plot ||
		!!item.algemeen.inhoud ||
		!!item.buitenruimte?.oppervlakteExterneBergruimte;
	const showIndeling = !!item.rooms || !!item.bedrooms;
	const showEnergy =
		!!item.energyClass ||
		!!item.algemeen?.isolatievormen?.length ||
		!!item.algemeen?.warmwatersoorten?.length;

	const totalBathRooms = item.etages?.reduce(
		(acc, etage) => acc + etage.badkamers.length,
		0,
	);
	const totalLevels = item.etages?.length ?? 0;
	const apartmentLevel = item.algemeen?.appartementWoonlaag ?? 0;
	const formatter = new Intl.ListFormat("nl", {
		style: "long",
		type: "conjunction",
	});
	const bathroomFloor = item.etages?.find(
		(etage) => etage.badkamers.length > 0,
	);

	const showVVeSpecs = !!Number(item.financieel?.overdracht.huurprijs);
	const financieelOverdracht = item.financieel?.overdracht;

	return (
		<div className="my-4 overflow-hidden sm:rounded-lg">
			{showOverdracht && (
				<>
					<div className="px-4 pb-5 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							Overdracht
						</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							{!!item.formattedPrice && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Vraagprijs
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{item.formattedPrice}
									</dd>
								</div>
							)}
							{!!Number(item.financieel?.overdracht.appartementVveBijdrage) && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										VvE Bijdrage
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										&euro; {item.financieel?.overdracht.appartementVveBijdrage}
									</dd>
								</div>
							)}
							{!!item.readableStatus && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">Status</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{item.readableStatus}
									</dd>
								</div>
							)}
							{!!item.financieel?.overdracht?.aanvaarding && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Aanvaarding
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{acceptanceOptions[item.financieel.overdracht.aanvaarding]}
									</dd>
								</div>
							)}
						</dl>
					</div>
				</>
			)}
			{showBouwDetails && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">Bouw</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							{cnTypeOptions[item.algemeen?.woonhuistype] && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Soort huis
									</dt>
									<dd className="mt-1 text-sm text-gray-900 capitalize sm:col-span-2 sm:mt-0">
										{cnTypeOptions[item.algemeen?.woonhuistype]}
									</dd>
								</div>
							)}
							{cnTypeOptions[item.algemeen?.appartementsoort] && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Soort huis
									</dt>
									<dd className="mt-1 text-sm text-gray-900 capitalize sm:col-span-2 sm:mt-0">
										{cnTypeOptions[item.algemeen?.appartementsoort]}
									</dd>
								</div>
							)}
							{cnTypeOptions[item.algemeen?.bouwvorm] && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Soort bouw
									</dt>
									<dd className="mt-1 text-sm text-gray-900 capitalize sm:col-span-2 sm:mt-0">
										{cnTypeOptions[item.algemeen?.bouwvorm]}
									</dd>
								</div>
							)}
							{!!item.algemeen?.bouwjaar && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Bouwjaar
									</dt>
									<dd className="mt-1 text-sm text-gray-900 capitalize sm:col-span-2 sm:mt-0">
										{item.algemeen?.bouwjaar}
									</dd>
								</div>
							)}
							{!!item.algemeen?.bijzonderheden?.length > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Bijzonderheden
									</dt>
									<dd className="mt-1 text-sm text-gray-900 capitalize sm:col-span-2 sm:mt-0">
										{formatter.format(
											item.algemeen?.bijzonderheden.map(
												(x) => specialOptions[x],
											),
										)}
									</dd>
								</div>
							)}
							{/* {item.buildYear && (
                <div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
                  <dt className="text-sm font-medium text-gray-500">Bouwjaar</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {item.buildYear}
                  </dd>
                </div>
              )} */}
						</dl>
					</div>
				</>
			)}
			{showOppervlakte && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							Oppervlakte &amp; inhoud
						</p>
					</div>

					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							{(!!item.livingArea ||
								!!item.detail?.buitenruimte?.oppervlakteExterneBergruimte) && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Gebruiksoppervlakten
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0" />
								</div>
							)}
							{!!Number(item.livingArea) && (
								<div className="py-1 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="pl-4 text-sm font-medium text-gray-500">
										Wonen
									</dt>
									<dd className="mt-1 text-sm text-gray-900 max-sm:pl-4 sm:col-span-2 sm:mt-0">
										{item.livingArea}{" "}
										<span className="ordinal">
											m<sub className="-top-1">2</sub>
										</span>
									</dd>
								</div>
							)}
							{!!item?.buitenruimte?.oppervlakteExterneBergruimte && (
								<div className="py-1 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="pl-4 text-sm font-medium text-gray-500">
										Externe bergruimte
									</dt>
									<dd className="mt-1 text-sm text-gray-900 max-sm:pl-4 sm:col-span-2 sm:mt-0">
										{item.buitenruimte.oppervlakteExterneBergruimte}{" "}
										<span className="ordinal">
											m<sub className="-top-1">2</sub>
										</span>
									</dd>
								</div>
							)}
							{!!Number(item.plot) && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">Perceel</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{item.plot}{" "}
										<span className="ordinal">
											m<sub className="-top-1">2</sub>
										</span>
									</dd>
								</div>
							)}
							{!!Number(item.algemeen.inhoud) && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">Inhoud</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{item.algemeen.inhoud}{" "}
										<span className="ordinal">
											m<sub className="-top-1">3</sub>
										</span>
									</dd>
								</div>
							)}
						</dl>
					</div>
				</>
			)}
			{showIndeling && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							Indeling
						</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							{!!Number(item.rooms) && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Aantal kamers
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{item.rooms} kamers{" "}
										{!!item.bedrooms && (
											<span>({item.bedrooms} slaapkamers)</span>
										)}
									</dd>
								</div>
							)}
							{totalBathRooms > 0 && (
								<>
									<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
										<dt className="text-sm font-medium text-gray-500">
											Aantal badkamers
										</dt>
										<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
											{totalBathRooms}{" "}
											{totalBathRooms > 1 ? "badkamers" : "badkamer"}{" "}
											{item.amountOfSeperateToilets > 0 && (
												<>
													en {item.amountOfSeperateToilets}{" "}
													{item.amountOfSeperateToilets > 1
														? "aparte toiletten"
														: "apart toilet"}
												</>
											)}
										</dd>
									</div>
									<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
										<dt className="text-sm font-medium text-gray-500">
											Badkamervoorzieningen
										</dt>
										<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
											{formatBathroomAmentities(
												bathroomFloor?.badkamers[0]?.voorzieningen ?? [],
											)}
										</dd>
									</div>
								</>
							)}
							{totalLevels > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Aantal woonlagen
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{totalLevels} {totalLevels > 1 ? "woonlagen" : "woonlaag"}
									</dd>
								</div>
							)}
							{apartmentLevel > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Gelegen op
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{apartmentLevel}e woonlaag
									</dd>
								</div>
							)}
						</dl>
					</div>
				</>
			)}
			{showEnergy && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">Energie</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							{!!item.energyClass && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Energielabel
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{item.energyClass}
									</dd>
								</div>
							)}

							{!!item.algemeen?.isolatievormen?.length > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Isolatie
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{formatter.format(
											item.algemeen?.isolatievormen.map(
												(x) => isolationOptions[x],
											),
										)}
									</dd>
								</div>
							)}
							{!!item.algemeen?.warmwatersoorten?.length > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Warm water
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{formatter.format(
											item.algemeen?.warmwatersoorten.map(
												(x) => heatingOptions[x],
											),
										)}
									</dd>
								</div>
							)}
						</dl>
					</div>
				</>
			)}
			{(!!liggingOptions[item.algemeen?.liggingen] ||
				!!item.buitenruimte?.tuintypes > 0) && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							Buitenruimte
						</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							{!!liggingOptions[item.algemeen?.liggingen] && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">Ligging</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{liggingOptions[item.algemeen?.liggingen]}
									</dd>
								</div>
							)}

							{!!item.buitenruimte?.tuintypes > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">Tuin</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{tuinOptions[item.buitenruimte.tuintypes]}
									</dd>
								</div>
							)}
						</dl>
					</div>
				</>
			)}
			{!!bergingOptionsSoort[item.buitenruimte?.schuurBergingSoort] && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							Bergruimte
						</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Schuur/berging
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{bergingOptionsSoort[item.buitenruimte.schuurBergingSoort]}
								</dd>
							</div>

							{!!item.buitenruimte.schuurBergingVoorzieningen > 0 && (
								<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
									<dt className="text-sm font-medium text-gray-500">
										Voorzieningen
									</dt>
									<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
										{formatter.format(
											item.buitenruimte.schuurBergingVoorzieningen.map(
												(a) => bergingVoorzieningen[a],
											),
										)}
									</dd>
								</div>
							)}
						</dl>
					</div>
				</>
			)}
			{!!showVVeSpecs && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							VvE checklist
						</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Inschrijving KvK
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{financieelOverdracht.vveKvkInschrijving ? "Ja" : "Nee"}
								</dd>
							</div>

							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Jaarlijkse vergadering
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{financieelOverdracht.vveVergadering ? "Ja" : "Nee"}
								</dd>
							</div>

							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Periodieke bijdrage
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{financieelOverdracht.vvePeriodiekeBijdrage ? "Ja" : "Nee"}
								</dd>
							</div>

							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Reservefonds aanwezig
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{financieelOverdracht.vveReservefonds ? "Ja" : "Nee"}
								</dd>
							</div>

							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Onderhoudsplan
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{financieelOverdracht.vveOnderhoudsverwachting ? "Ja" : "Nee"}
								</dd>
							</div>

							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Opstalverzekering
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{financieelOverdracht.vveOpstalverzekering ? "Ja" : "Nee"}
								</dd>
							</div>
						</dl>
					</div>
				</>
			)}
			{!!item.buitenruimte?.parkeerfaciliteiten && (
				<>
					<div className="px-4 pb-5 mt-6 sm:px-6">
						<p className="text-lg font-bold leading-6 text-gray-900">
							Parkeergelegenheid
						</p>
					</div>
					<div className="px-4 py-5 border-t border-gray-200 sm:p-0">
						<dl className="sm:divide-gray-200 sm:divide-y">
							<div className="py-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:px-6 sm:py-5">
								<dt className="text-sm font-medium text-gray-500">
									Soort parkeergelegenheid
								</dt>
								<dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
									{formatOptions(item.buitenruimte.parkeerfaciliteiten)}
								</dd>
							</div>
						</dl>
					</div>
				</>
			)}
		</div>
	);
};
